export default __webpack_public_path__ + "resources/icons/d130-36cd.png";